import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=c11539b8&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=c11539b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11539b8",
  null
  
)

export default component.exports